import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import UserLayout from './components/UserLayout';
import Login from './pages/Login';
import Home from './pages/Home';
import Users from './pages/Users';
import Plugins from './pages/Plugins';
import Licences from './pages/Licences';
import Posts from './pages/Posts';
import PostDetail from './pages/PostDetail';
import PluginSettings from './pages/PluginSettings';
import AdminProfile from './pages/AdminProfile';
import UserHome from './pages/UserHome';
import UserDownloads from './pages/UserDownloads';
import UserMyLicenses from './pages/UserMyLicenses';
import UserPosts from './pages/UserPosts';
import UserPluginSettings from './pages/UserPluginSettings';
import UserProfile from './pages/UserProfile';
import Support from './pages/Support';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <ProtectedRoute requireUserType="admin">
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="users" element={<Users />} />
            <Route path="plugins" element={<Plugins />} />
            <Route path="licences" element={<Licences />} />
            <Route path="posts" element={<Posts />} />
            <Route path="posts/:id" element={<PostDetail />} />
            <Route path="plugin-settings" element={<PluginSettings />} />
            <Route path="admin-profile" element={<AdminProfile />} />
          </Route>

          <Route
            path="/panel"
            element={
              <ProtectedRoute requireUserType="user">
                <UserLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<UserHome />} />
            <Route path="downloads" element={<UserDownloads />} />
            <Route path="my-licenses" element={<UserMyLicenses />} />
            <Route path="posts" element={<UserPosts />} />
            <Route path="posts/:id" element={<PostDetail />} />
            <Route path="plugin-settings" element={<UserPluginSettings />} />
            <Route path="support" element={<Support />} />
            <Route path="profile" element={<UserProfile />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;